

 document.addEventListener("DOMContentLoaded", function() {
    // Get all elements with the specified classes
    var activeItems1 = document.querySelectorAll('.header__menu-item.list-menu__item--active');
    var activeItems2 = document.querySelectorAll('.header__active-menu-item');

     // var activeItems3 = document.querySelectorAll('.mega-menu__item-link.list-menu__item');
    
    // Array to hold the breadcrumb HTML
    var breadcrumbArray = [];
    
    // Array to hold the structured data
    var structuredDataArray = [];
    var position = 1;

    // Add the "Home" link at the beginning
    breadcrumbArray.push('<li class="breadcrumb-item"><a href="/">Home</a></li>');
    structuredDataArray.push({
      "@type": "ListItem",
      "position": position++,
      "name": "Home",
      "item": window.location.origin
    });

    // Function to collect text content and href from NodeList
    function collectBreadcrumbData(nodeList) {
      nodeList.forEach(function(item) {
        if (item) {
          var href = item.getAttribute('href');
          var text = item.textContent.trim();
          breadcrumbArray.push(`<li class="breadcrumb-item"><a href="${href}">${text}</a></li>`);
          structuredDataArray.push({
            "@type": "ListItem",
            "position": position++,
            "name": text,
            "item": href
          });
        } else {
          var text = item.textContent.trim();
          breadcrumbArray.push(`<li class="breadcrumb-item active">${text}</li>`);
          structuredDataArray.push({
            "@type": "ListItem",
            "position": position++,
            "name": text
          });
        }
      });
    }
    
    // Collect breadcrumb data from both NodeLists
    collectBreadcrumbData(activeItems2);
    collectBreadcrumbData(activeItems1);
    //  collectBreadcrumbData(activeItems3);
    
    // Join the array elements with a separator
    var breadcrumb = breadcrumbArray.join('<span class="breadcrumb-separator"><img src="//looopsmoments.com/cdn/shop/files/Breadcrumb_separator_1.svg?v=18220401362154376061" alt="" /></span>');
    
      var breadcrumbElements = document.querySelectorAll('.breadcrumb-collection-page');
      breadcrumbElements.forEach(function(breadcrumbElement) {
        breadcrumbElement.innerHTML = `<ul class="breadcrumb">${breadcrumb}</ul>`; // Use innerHTML to insert links
      });

    // Create and inject the structured data script
    var structuredData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": structuredDataArray
    };

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);
  });